const isMissingRequiredSelection = (selectedFacets, treeLevelVariants, facetConfig, currentNode) => {
  return Boolean(
    facetConfig?.requiresUserSelection && (!currentNode?.facetKey || !selectedFacets.includes(currentNode?.facetKey)) && treeLevelVariants.length > 1
  );
};
export {
  isMissingRequiredSelection
};
//# sourceMappingURL=is-missing-required-selection.js.map
